require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[16],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(212);


/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ContextProvider = _interopRequireDefault(__webpack_require__(93));

exports.ContextProvider = _ContextProvider["default"];

var _withContext = _interopRequireDefault(__webpack_require__(213));

exports.withContext = _withContext["default"];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = withContext;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _ContextProvider = __webpack_require__(93);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var forOwn = _utils.lodash.forOwn,
    assign = _utils.lodash.assign;

function addStringProperty(dest, source, name, key) {
  var segments = name.split('.');
  var value = source;

  for (var i = 0; i < segments.length; i += 1) {
    value = value[segments[i]];
  }

  dest[key != null ? key : segments.pop()] = value;
}

function addObjectProperty(dest, source, obj) {
  forOwn(obj, function (value, key) {
    addStringProperty(dest, source, value, key);
  });
}

function addFunctionProperty(dest, source, func, ownProps) {
  var result = func(source, ownProps);

  if (result && typeof result === 'object') {
    assign(dest, result);
  }
}

function addProperty(dest, source, arg, ownProps) {
  switch (typeof arg) {
    case 'string':
      addStringProperty(dest, source, arg);
      break;

    case 'object':
      addObjectProperty(dest, source, arg);
      break;

    case 'function':
      addFunctionProperty(dest, source, arg, ownProps);
      break;

    default:
  }
}

function withContext() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (ComponentClass) {
    // eslint-disable-line func-names
    var WithContext = /*#__PURE__*/function (_Component) {
      (0, _inheritsLoose2["default"])(WithContext, _Component);

      function WithContext() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = WithContext.prototype;

      _proto.render = function render() {
        var _this = this;

        return /*#__PURE__*/_react["default"].createElement(_ContextProvider.BiContext.Consumer, null, function (biContext) {
          var _this$props = _this.props,
              contextForwardRef = _this$props.contextForwardRef,
              others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["contextForwardRef"]);
          var newProps = {};

          if (biContext) {
            if (args == null || args.length === 0) {
              newProps.context = biContext;
            } else {
              args.forEach(function (arg) {
                return addProperty(newProps, biContext, arg, _this.props);
              });
            }
          }

          return /*#__PURE__*/_react["default"].createElement(ComponentClass, (0, _extends2["default"])({}, others, newProps, {
            ref: contextForwardRef
          }));
        });
      };

      return WithContext;
    }(_react.Component);

    (0, _defineProperty2["default"])(WithContext, "propTypes", {
      contextForwardRef: _propTypes["default"].any
    });
    (0, _defineProperty2["default"])(WithContext, "contextTypes", {
      biContext: _propTypes["default"].object
    });
    WithContext.WrappedComponent = ComponentClass;
    return _react["default"].forwardRef(function (props, ref) {
      return /*#__PURE__*/_react["default"].createElement(WithContext, (0, _extends2["default"])({}, props, {
        contextForwardRef: ref
      }));
    });
  };
}

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = exports.BiContext = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var reactProps = {
  children: 1,
  key: 1,
  ref: 1
};
var BiContext = (0, _react.createContext)({});
exports.BiContext = BiContext;

var ContextProvider = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ContextProvider, _Component);

  function ContextProvider() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ContextProvider.prototype;

  _proto.render = function render() {
    var _this = this;

    var prunedProps = {};
    Object.keys(this.props).forEach(function (key) {
      if (!reactProps[key]) {
        prunedProps[key] = _this.props[key];
      }
    });
    return /*#__PURE__*/_react["default"].createElement(BiContext.Consumer, null, function (biContext) {
      return /*#__PURE__*/_react["default"].createElement(BiContext.Provider, {
        value: (0, _extends2["default"])({}, biContext, prunedProps)
      }, _this.props.children);
    });
  };

  return ContextProvider;
}(_react.Component);

exports["default"] = ContextProvider;
(0, _defineProperty2["default"])(ContextProvider, "propTypes", {
  children: _propTypes["default"].node
});

/***/ })

},[[211,0]]]);
});